import React, { Component } from 'react';
import { Popover, OverlayTrigger, Col} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';

class EventsItem extends Component {
    render() {
        const { item } = this.props;
        if (!this.props.edit) {
            return (
                <div>
                    <OverlayTrigger rootClose placement="bottom" overlay={
                        <Popover id={`${item}-popover`}>
                            <h5>{this.props.users[this.props.eventItems.data[item].user].displayName}</h5>
                        </Popover>
                    }>
                        <Col md={3} sm={6} xs={12} key={`${item}-item`} style={{"cursor":"pointer"}}>
                            <h5>{this.props.items.data[this.props.eventItems.data[item].item].title}</h5> <FontAwesomeIcon className="text-primary" size="sm" icon={faCoins} fixedWidth /> {parseInt(this.props.eventItems.data[item].dkp, 10)}
                        </Col>
                    </OverlayTrigger>
                </div>
            )
        } else {
            return (
                <div>
                    edit
                </div>
            )
        }
    }
}

export default EventsItem;


// WEBPACK FOOTER //
// ./src/Officer/EventsItem.js